/* eslint-disable @typescript-eslint/no-floating-promises */
import React from 'react';
import { openApiFetchDelete, openApiFetchGet, openApiFetchPost } from '../../store/openApiFetch';
import { Content, Panel, PanelBody, PanelHorizontalSpacing, Tray } from '../elements';
import { AssetDropzone } from '../Surveys/Common/AssetDropzone';
import { DocumentsList } from '../utils/DocumentsList';
import { useReactAsync } from '../utils/useReactAsync';
import { TopBar } from './Common/TopBar';

async function loadEquipmentAssets({ equipmentId }: { equipmentId: string }) {
    const result = await openApiFetchGet('/api/equipmentAsset', { equipmentId });
    return result;
}

export function EquipmentDocuments(props: { params: { id?: string } }) {
    if (!props.params.id) {
        throw new Error('Equipment id is not provided');
    }
    const { data, reload } = useReactAsync(loadEquipmentAssets, { equipmentId: props.params.id }, []);

    const removeDocument = async (assetId: string) => {
        await openApiFetchDelete('/api/equipmentAsset/{equipmentAssetId}', { equipmentAssetId: assetId });
        await reload();
    };

    const updateDocument = async (assetId: string, body: { name?: string }) => {
        await openApiFetchPost('/api/equipmentAsset/{equipmentAssetId}', { equipmentAssetId: assetId }, { name: body.name ?? '' });
        await reload();
    };

    return (
        <>
            <TopBar equipmentId={props.params.id} activeTab="documents" />
            <Content>
                <Tray>
                    <Panel>
                        <PanelBody>
                            <PanelHorizontalSpacing>
                                <AssetDropzone
                                    acceptedFiles=".png,.jpeg,.jpg,.pdf,.doc,.docx,.zip"
                                    onComplete={reload}
                                    equipmentId={props.params.id}
                                    autoProcessQueue={true}
                                />
                            </PanelHorizontalSpacing>
                            <PanelBody noPadding={true}>
                                {data && (
                                    <DocumentsList
                                        assets={data}
                                        equipmentId={props.params.id}
                                        blueHeader={true}
                                        onRemove={async (assetId: string) => removeDocument(assetId)}
                                        onUpdate={updateDocument}
                                    />
                                )}
                            </PanelBody>
                        </PanelBody>
                    </Panel>
                </Tray>
            </Content>
        </>
    );
}
